import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findNations = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/nations${query}`, { headers });
};

export const findNationById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/nations/${id}`, { headers });
};
